import React from 'react';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import {
  FDAlert,
  FDPrimaryActionButton,
  FDPrimaryActionIconButton,
  FDStack,
} from '@facet-wealth/design';
import { DialogActions, DialogContent } from 'Views/Page/Content/Modal/Components';
import fr from 'facet-rest';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import { dataAttrs } from 'Helpers/Testing';

const ExpensesReducibleByStepLayout = () => {
  const {
    resource, onSubmit, saving,
  } = useMetaLayoutContext();
  const { loadModalCollectionByLink } = useModalContext();

  return (
    <>
      <MetaControlField attr={'explainer1'} />
      <DialogContent scrollKey={resource?.type() + resource?.id()}>
        <FDStack direction={'column'} alignItems={'stretch'} spacing={2}>
          <MetaControlField attr={'explainer2'} />
          <MetaControlField attr={'instructions'} />
          <MetaControlField attr={'instructionSubtext'} />
          <MetaControlField attr={'expensesReducibilityPercentage'} />
          <FDAlert status={'info'} title={resource.metaField('infoText').attr('prompt')} description={resource.attr('infoText')} />
          <MetaControlField attr={'moreInfoArticle'} />
        </FDStack>
      </DialogContent>
      <DialogActions>
        <FDStack wrap spacing={1} alignItems="center">
          {resource.withRelationship(fr.relationships.previousLink.name,
            (rel) => (
              <FDPrimaryActionIconButton
                icon="chevronLeft"
                onClick={() => {
                  loadModalCollectionByLink(rel.link('related').url());
                }}
              />
            ),
            () => null)}
          <FDPrimaryActionButton
            {...dataAttrs('continue-btn', resource)}
            label="Continue →"
            loading={saving}
            onClick={onSubmit}
          />
        </FDStack>
      </DialogActions>
    </>
  );
};

ExpensesReducibleByStepLayout.defaultProps = {
};

ExpensesReducibleByStepLayout.propTypes = {
};

export default ExpensesReducibleByStepLayout;
